module.exports = "/images/vendor/flag-icon-css/flags/4x3/tg.svg?025deae88a72695eb60991ab1247714f";